import { useEffect, useState } from 'react';
import { getReferencePlaceKinds } from '../../services/referencePlacesService';
import { normalizeReferencePlaceCatalog } from '../utils/referencePlaces';

let catalogMemory = null;
let catalogInflight = null;

function loadReferencePlaceKindsCached() {
  if (catalogMemory) return Promise.resolve(catalogMemory);
  if (!catalogInflight) {
    catalogInflight = getReferencePlaceKinds()
      .then((response) => {
        if (response?._httpOk) {
          catalogMemory = response;
          return response;
        }
        catalogInflight = null;
        return response;
      })
      .catch((error) => {
        catalogInflight = null;
        throw error;
      });
  }
  return catalogInflight;
}

/**
 * Catálogo del switcher de lugares. Un GET al montar la vista (no espera
 * `mapReady`); se reusa entre remounts de la sesión.
 *
 * @param {{ enabled?: boolean }} options
 * @returns {{ kinds: Array, loading: boolean }}
 */
export function useReferencePlacesCatalog({ enabled = false } = {}) {
  const [kinds, setKinds] = useState(() => (
    catalogMemory ? normalizeReferencePlaceCatalog(catalogMemory) : []
  ));
  const [loading, setLoading] = useState(() => enabled && !catalogMemory);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    if (!catalogMemory) setLoading(true);

    loadReferencePlaceKindsCached()
      .then((response) => {
        if (cancelled) return;
        if (!response?._httpOk) {
          console.error(
            'No se pudo cargar el catálogo de lugares de referencia',
            response?._httpStatus,
            response?.message,
          );
          setKinds([]);
          return;
        }
        setKinds(normalizeReferencePlaceCatalog(response));
      })
      .catch((error) => {
        if (cancelled || error?.name === 'AbortError') return;
        console.error('No se pudo cargar el catálogo de lugares de referencia', error);
        setKinds([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { kinds, loading };
}
